import gql from 'graphql-tag';

import { VISIBLE_RESOURCES_STATUSES } from 'src/data/performance';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query IntegrationPerformanceData(
    $customerId: ID!
    $accountId: ID
    $dataSource: PerformanceCenterDataSource
    $statuses: [IntegrationAssetStatus!]
  ) {
    integrationAssets(
      customerId: $customerId
      dataSource: $dataSource
      accountId: $accountId
      statuses: $statuses
    ) {
      id
      performanceData
    }
  }
`;

export const queryIntegrationPerformanceData = (
  { customerId, dataSource, accountId },
  options = null
) => {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      dataSource,
      accountId,
      statuses: VISIBLE_RESOURCES_STATUSES,
    },
    options: {
      abortSignal: options?.abortSignal,
    },
  }).then(({ data }) => getSingleProp(data));
};
